import SelectableController from './selectable_controller'

export default class extends SelectableController {
  static values = {
    url: { type: String, default: '/fields' },
    auditorId: { type: String, default: '' }
  }

  declare auditorIdValue: string

  settings = {
    plugins: ['virtual_scroll', 'remove_button'],
    preload: true
  }

  buildUrl (query: string): string {
    const joinOperator = this.urlValue.includes('?') ? '&' : '?'

    let url = `${this.urlValue}${joinOperator}page=${this.currentPage}`

    if (query !== '') {
      url += `&query=${encodeURIComponent(query)}`
    }
    if (this.auditorIdValue !== '') {
      url += `&auditor_id=${encodeURIComponent(this.auditorIdValue)}`
    }
    return url
  }

  changeAuditor ({ detail: { auditorId } }: { detail: { auditorId: string } }): void {
    this.auditorIdValue = auditorId
  }

  auditorIdValueChanged (): void {
    if (this.plugin === undefined) return

    this.plugin.clear(true)
    this.plugin.clearOptions()

    this.currentPage = 1
    this.nothingMoreToLoad = false

    this.plugin.load('')
  }
}
